import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
import { isAxiosError, OpenApiDataException, OpenApiException } from '../apis/service/exception';
import { HttpServiceHelper } from './utils/HttpServiceHelper';
let OpenApiHttp = class OpenApiHttp extends HttpServiceHelper {
    constructor(httpClient, errorHandlerService, i18n) {
        super(errorHandlerService);
        this.httpClient = httpClient;
        this.errorHandlerService = errorHandlerService;
        this.i18n = i18n;
        this.configErrorHandler();
    }
    // #region 全局错误处理相关
    configErrorHandler() {
        this.errorHandlerService.addHandler(error => {
            if (OpenApiDataException.is(error)) {
                this._errorDisplayProxy(error.data?.data?.error_message);
                return true;
            }
            if (!OpenApiException.is(error)) {
                return false;
            }
            // todo 500错误处理
            const openApiError = error?.response?.data;
            if (!openApiError || !openApiError.error_message) {
                return false;
            }
            this._errorDisplayProxy(openApiError.error_message);
            return true;
        });
    }
    // #endregion
    request(config) {
        config = {
            ...config,
            params: {
                ...config?.params,
            },
        };
        return this.httpClient(config).then(res => {
            const data = res.data;
            if (data.status === false) {
                throw OpenApiDataException.mark(res);
            }
            return res.data;
        }, error => {
            if (!isAxiosError(error)) {
                throw error;
            }
            error = OpenApiException.mark(error);
            throw error;
        });
    }
};
OpenApiHttp = __decorate([
    injectable(),
    __param(0, inject(Symbols.HttpClient)),
    __param(1, inject(Symbols.ErrorHandlerService)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], OpenApiHttp);
export { OpenApiHttp };
